<script setup>
import {computed} from "vue";

const props = defineProps({
  name: {type: String, required: true},
  size: {type: [Number, String], default: 22},
})

const fontSize = computed(() => typeof props.size === 'number' ? props.size + 'px' : props.size)
</script>

<template>
  <span class="ww-icon" :style="{fontSize}" aria-hidden="true">{{ props.name }}</span>
</template>
